export default __webpack_public_path__ + "static/media/icon-card-cabin-log.91f80d4c.svg";